import { render, staticRenderFns } from "./editaccessusergroup.vue?vue&type=template&id=61554600&"
import script from "./editaccessusergroup.vue?vue&type=script&lang=js&"
export * from "./editaccessusergroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports